import { createSelector } from 'reselect';

// Config
import { getAppThemeSelector } from '@redux/reducers/app/appSelector';
import { getShowAppDarkModeSelector } from '../../App.state';

const paymentDetailsState = createSelector(
  [getAppThemeSelector, getShowAppDarkModeSelector],
  (theme, showDarkMode) => ({
    theme,
    showDarkMode,
  }),
);

export default paymentDetailsState;
